<template>
  <main>
    <div class="tree">

      <div class="section">
        <users-list :list="list"
                    :allow-drag="false" />
      </div>

      <infinite-loading :identifier="infiniteId"
                        @infinite="load">
        <div slot="no-results"
             class="empty-state">{{$t('message.generics.message.noResultsFound')}}</div>
        <div slot="no-more"></div>
      </infinite-loading>
    </div>
  </main>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import UsersList from "@components/modules/users/list/UsersList";
import EventBus from "@packages/event-bus";
import { redirectUtils } from "../../packages/util/redirect/redirectUtils";

export default {
  components: {
    UsersList,
    InfiniteLoading,
  },

  data() {
    return {
      list: [],
      page: 0,
      showLoadButton: false,
      permissionsList: [],
      infiniteId: +new Date(),
      filter: undefined,
    };
  },

  methods: {
    async load($state) {
      const userLoginSearchRes = await this.$api.userLogin.search({
        page: this.page,
        filter: this.filter,
      });

      if (userLoginSearchRes.content.length !== 0) {
        this.list.push(...userLoginSearchRes.content);
        this.page++;

        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }
    },
    async reloadTableHandler() {
      this.page = 0;
      this.list = [];
      this.infiniteId++;
    },
    async searchHandler(search) {
      this.page = 0;
      this.list = [];
      this.filter = search;
      this.infiniteId++;
    },
  },

  computed: {
    isPartner() {
      return this.$store.state.users.user.tipo === "PARCEIRO";
    },
  },

  async mounted() {
    // const permissions = await this.$api.auth.permissions();

    // this.permissionsList = Object.keys(permissions).map((key) => {
    //   return permissions[key];
    // });

    EventBus.$on("RELOAD_USER_TABLE", this.reloadTableHandler);
    EventBus.$on("SEARCH_USER_TABLE", this.searchHandler);
  },

  beforeMount() {
    const url = this.isPartner ? redirectUtils.mountUrl('/new/parceiro/configuracoes/usuarios') : redirectUtils.mountUrl('/new/estabelecimento/configuracoes/usuarios');
    location.assign(url)
  },

  beforeDestroy() {
    this.load();
    EventBus.$off("RELOAD_USER_TABLE", this.reloadTableHandler);
    EventBus.$off("SEARCH_USER_TABLE", this.searchHandler);
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

main {
  overflow: auto;

  .tree {
    //display: flex;

    .section {
      max-width: 100%;
    }

    .tree-header {
      border-bottom: 1px solid #c8c8c8;
      margin-left: 0;

      &.tree-header_permissions {
        display: grid;

        grid-template-columns: 200px 200px 200px 200px 200px 200px 200px 200px 200px 200px;
        gap: 30px;
      }

      h1 {
        font-weight: 600;
        font-size: 15px;
      }

      &.tree-header_drag {
        margin-left: 24px;
      }
    }

    .empty-state {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0;
      cursor: pointer;
      height: 55px;
      border-bottom: 1px solid #c8c8c8;
      user-select: none;
    }

    .btn {
      display: block;
      margin: 15px auto;
      color: $primary;
    }
  }
}
</style>
